import { CERTIFICATION_COLORS } from '@/shared/api/openmetadata/constants';

/**
 * 메달리온 아키텍처 Data Zone 순서 (Gold → Silver → Bronze)
 */
export const DATA_ZONE_ORDER = ['Gold', 'Silver', 'Bronze'] as const;

/**
 * 데이터 존별 색상 맵 (CERTIFICATION_COLORS 기반)
 */
export const DATA_ZONE_COLOR_MAP = {
  Gold: CERTIFICATION_COLORS.Gold,
  Silver: CERTIFICATION_COLORS.Silver,
  Bronze: CERTIFICATION_COLORS.Bronze,
} as const;

/**
 * Ant Design Tag용 색상 맵
 */
export const DATA_ZONE_TAG_COLOR_MAP = {
  Gold: 'gold',
  Silver: 'default',
  Bronze: 'orange',
} as const;

/**
 * 품질 상태 색상 (light/container/state)
 */
export const QUALITY_STATUS_COLORS = {
  GOOD: '#2FBC91',
  POOR: '#F05666',
  WARNING: '#F05666',
  UNKNOWN: '#292929',
} as const;

/**
 * 품질 상태별 차트 색상 맵 (DonutChart, BarChart용)
 */
export const QUALITY_CHART_COLOR_MAP = {
  양호: QUALITY_STATUS_COLORS.GOOD,
  미흡: QUALITY_STATUS_COLORS.WARNING,
  '판정 불가': QUALITY_STATUS_COLORS.UNKNOWN,
} as const;
